import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getCompanyId, setCompanyId } from "@/lib/api";

const CompanyContext = createContext(null);
export const useCompany = () => useContext(CompanyContext);

export function CompanyProvider({ children }) {
  const [companies, setCompanies] = useState([]);
  const [current, setCurrent] = useState(getCompanyId());

  const reload = useCallback(() => api.get("/companies").then((r) => {
    setCompanies(r.data.companies);
    setCompanyId(r.data.current);
    setCurrent(r.data.current);
  }).catch(() => {}), []);

  useEffect(() => { reload(); }, [reload]);

  const switchCompany = useCallback((id) => { setCompanyId(id); setCurrent(id); }, []);
  const company = companies.find((c) => c.id === current);

  return (
    <CompanyContext.Provider value={{ companies, current, company, switchCompany, reload }}>
      {children}
    </CompanyContext.Provider>
  );
}
